import { extendTheme } from '@companydotcom/potion';
import components from './components';
import customStyles from './extensions';
import layerStyles from './layer-styles';

export const DashboardTheme = extendTheme({
  components: { ...components, ...customStyles },
  layerStyles,
});
